import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useArchivedJobProspectsState() {
  return useAppState();
}

export function useArchivedJobProspectsActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      archivedJobProspects: [],
      pageNumber: 1,
      numberOfPages: 1,
      selectedJobProspectIds: [],
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response, selectedJobProspectIds: [] }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function toggleJobProspectSelection(id) {
    dispatch((appState) => {
      const current = appState.selectedJobProspectIds || [];
      const updated = current.includes(id)
        ? current.filter(selectedId => selectedId !== id)
        : [...current, id];
      return { ...appState, selectedJobProspectIds: updated };
    });
  }

  function selectAllJobProspects(ids) {
    dispatch((appState) => ({
      ...appState,
      selectedJobProspectIds: ids,
    }));
  }

  function clearSelection() {
    dispatch((appState) => ({
      ...appState,
      selectedJobProspectIds: [],
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    clearFeedback,
    toggleJobProspectSelection,
    selectAllJobProspects,
    clearSelection,
  };
}
